// extracted by mini-css-extract-plugin
export default {"title":"policy_title__REECZ","text":"policy_text__3yauq","mr100":"policy_mr100__ufiXH","mr50":"policy_mr50__VZq95"};